import {
  apiGET
} from "./chunk-NB6PR3JZ.mjs";

// src/adapters/kyc.ts
var getKYCData = async () => await apiGET("/players/kyc/documents/pending");
var getKYCVerificationData = async () => await apiGET("/users/documents", null);
var getKYCOnboardingData = async ({
  documentType,
  requestParams = {}
}) => {
  const params = { documentType, ...requestParams };
  return await apiGET("/onboardings", { params });
};
var getKYCStatusData = async (playerId) => {
  return await apiGET(`/players/${playerId}/kyc-status`, null);
};
var getKYCRejectReasons = async (documentId) => await apiGET(`/documents/${documentId}/reject-reasons`, null);
var getRgRiskReview = async () => {
  return await apiGET("/rg-risk-review");
};

export {
  getKYCData,
  getKYCVerificationData,
  getKYCOnboardingData,
  getKYCStatusData,
  getKYCRejectReasons,
  getRgRiskReview
};
